import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'SUPP_FOURN',
  title: 'Comment supprimer un fournisseur ? ',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Vous pouvez supprimer un fournisseur une fois que la mission est terminée et à n’importe quel moment de votre abonnement sur la plateforme. Vous aurez bien sûr la possibilité de lui renvoyer une invitation pour récupérer ses attestations.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous dans l’onglet « Fournisseurs » '
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SUPP_FOURN/FR_SUPP_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Sur la ligne du fournisseur que vous souhaitez supprimer, cliquez sur les trois points à droite'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SUPP_FOURN/FR_SUPP_FOURN_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliquez ensuite sur « Supprimer de ma liste »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_SUPP_FOURN/FR_SUPP_FOURN_3.png`
  }]
};
